// variant chip+collapse: radio変更時に summary 内の data-variant-current-value を更新
// 加えて、選択直後に details を閉じる（UX的に「選んだら閉じる」）

(() => {
  const update = (radio) => {
    if (!radio || !radio.checked) return;
    const details = radio.closest('.variant-option-collapsible');
    if (!details) return;
    const value = radio.value;
    const target = details.querySelector('[data-variant-current-value]');
    if (target) target.textContent = value;
    // close after selection (slight delay so user sees the visual feedback)
    setTimeout(() => { details.open = false; }, 200);
  };

  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || t.type !== 'radio') return;
    if (!t.closest('.variant-option-collapsible')) return;
    update(t);
  }, true);

  // initial sync (in case of direct re-render)
  document.querySelectorAll('.variant-option-collapsible').forEach((d) => {
    const checked = d.querySelector('input[type="radio"]:checked');
    if (checked) {
      const value = checked.value;
      const target = d.querySelector('[data-variant-current-value]');
      if (target && !target.textContent.trim()) target.textContent = value;
    }
  });
})();
